import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteCollectionMutationVariables = Types.Exact<{
  input: Types.DeleteCollectionInput;
}>;


export type DeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection?: { __typename?: 'DeleteCollectionPayload', collection?: { __typename?: 'Collection', id: string } | null } | null };


export const DeleteCollection = /*#__PURE__*/ gql`
    mutation DeleteCollection($input: DeleteCollectionInput!) {
  deleteCollection(input: $input) {
    collection {
      id
    }
  }
}
    ` as unknown as DocumentNode<DeleteCollectionMutation, DeleteCollectionMutationVariables>;

          

          export const useDeleteCollectionMutation = (options?:MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>) => useMutation(DeleteCollection, options);
          

          export type DeleteCollectionMutationOptions = MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>;

          

          export type DeleteCollectionMutationResult = ReturnType<typeof useDeleteCollectionMutation>[1];

          
